import { ReactNode } from 'react';

import { DatetimeShow } from '@fhs/ui';

import {
  thanksgivingSubUSEndDate,
  thanksgivingSubUSStartDate,
  tripleStackUSEndDate,
  tripleStackUSStartDate,
} from '../constants';

export type LtoContentUSProps = {
  default?: ReactNode;
  tripleStack: ReactNode;
  thanksgivingSub: ReactNode;
};

export const LtoContentUS = ({
  tripleStack,
  default: defaultContent,
  thanksgivingSub,
}: LtoContentUSProps) => {
  return (
    <DatetimeShow
      after={thanksgivingSubUSStartDate}
      before={thanksgivingSubUSEndDate}
      default={
        <DatetimeShow
          after={tripleStackUSStartDate}
          before={tripleStackUSEndDate}
          default={defaultContent}
        >
          {tripleStack}
        </DatetimeShow>
      }
    >
      {thanksgivingSub}
    </DatetimeShow>
  );
};
